/* GYM customization: after a successful add-to-cart show a toast with View cart / Checkout and pulse the header cart icon. */
(function () {
  if (window.__gymCartUx) return;
  window.__gymCartUx = true;

  var toast;

  function pulse() {
    var el = document.querySelector('cart-icon, .header-actions__cart-icon');
    if (!el) return;
    el.classList.remove('gym-cart-pulse');
    void el.offsetWidth;
    el.classList.add('gym-cart-pulse');
    setTimeout(function () { el.classList.remove('gym-cart-pulse'); }, 2500);
  }

  function hide() {
    if (toast) toast.classList.remove('is-visible');
  }

  function show() {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'gym-atc-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<div class="gym-atc-toast__msg"><span class="gym-atc-toast__check" aria-hidden="true">\u2713</span> Added to cart</div>' +
        '<div class="gym-atc-toast__actions">' +
        '<a href="/cart" class="gym-atc-toast__btn gym-atc-toast__btn--ghost">View cart</a>' +
        '<a href="/checkout" class="gym-atc-toast__btn">Checkout</a>' +
        '</div>' +
        '<button type="button" class="gym-atc-toast__close" aria-label="Close">\u00d7</button>';
      document.body.appendChild(toast);
      toast.querySelector('.gym-atc-toast__close').addEventListener('click', hide);
    }
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(hide, 6000);
    pulse();
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = originalFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url)) {
        promise.then(function (res) { if (res && res.ok) show(); }).catch(function () {});
      }
      return promise;
    };
  }
})();
